export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'rpg',
    name: '角色扮演',
    icon: 'ri-sword-line',
    description: '沉浸式角色扮演游戏，开放世界探索、剧情驱动、角色成长',
    count: 4,
  },
  {
    slug: 'action',
    name: '动作冒险',
    icon: 'ri-flashlight-line',
    description: '高燃动作对战与冒险探索，考验操作与反应',
    count: 3,
  },
  {
    slug: 'moba',
    name: 'MOBA',
    icon: 'ri-team-line',
    description: '多人在线战术竞技，团队配合决胜战场',
    count: 1,
  },
  {
    slug: 'shooter',
    name: '射击',
    icon: 'ri-crosshair-line',
    description: '第一/第三人称射击游戏，枪林弹雨中生存制胜',
    count: 2,
  },
  {
    slug: 'casual',
    name: '休闲',
    icon: 'ri-gamepad-line',
    description: '轻松愉快的休闲游戏，解压娱乐首选',
    count: 2,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);